/* Mobile sticky add to cart.
   Shows after the tier selector scrolls away, hides near the final CTA and footer, and
   mirrors whichever price the hero currently has selected. */

(function () {
  'use strict';

  function initBar(bar) {
    if (bar.dataset.ssStickyInit === 'true') return;
    bar.dataset.ssStickyInit = 'true';

    var targetId = bar.getAttribute('data-target') || 'ss-buy-anchor';
    var priceEl = bar.querySelector('[data-sticky-price]');
    var btn = bar.querySelector('[data-sticky-btn]');

    var pastAnchor = false;
    var atEnd = false;

    function setVisible(on) {
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', String(!on));
      if (btn) btn.tabIndex = on ? 0 : -1;
    }

    function sync() { setVisible(pastAnchor && !atEnd); }

    /* ---- price mirroring ---- */

    function setPrice(text) {
      if (priceEl && text) priceEl.textContent = text;
    }

    // Whatever the hero server-rendered as active is the truth on load.
    function readInitialPrice() {
      var active = document.querySelector('[data-tier].is-active');
      if (!active) return;
      var shown = active.querySelector('[data-tier-price]');
      setPrice(shown ? shown.textContent.trim() : active.getAttribute('data-price-onetime'));
    }

    document.addEventListener('ss:tier:change', function (e) {
      if (e.detail && e.detail.price) setPrice(e.detail.price);
    });

    readInitialPrice();

    /* ---- scroll to the one place a tier can be chosen ---- */

    if (btn) {
      btn.addEventListener('click', function () {
        var target = document.getElementById(targetId);
        if (!target) return;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    }

    /* ---- visibility ---- */

    var anchor = document.getElementById(targetId);
    var tail = document.querySelector('.ss-final') ||
               document.querySelector('footer, .ss-footer');

    if ('IntersectionObserver' in window && anchor) {
      var anchorObs = new IntersectionObserver(function (entries) {
        var en = entries[0];
        if (!en) return;
        // Past it only when it has scrolled off the TOP, not before we reach it.
        pastAnchor = !en.isIntersecting && en.boundingClientRect.top < 0;
        sync();
      });
      anchorObs.observe(anchor);

      if (tail) {
        var tailObs = new IntersectionObserver(function (entries) {
          atEnd = !!(entries[0] && entries[0].isIntersecting);
          sync();
        });
        tailObs.observe(tail);
      }

      document.addEventListener('shopify:section:unload', function (e) {
        if (e.target === bar || !bar.isConnected) {
          anchorObs.disconnect();
          if (tail) tailObs.disconnect();
        }
      });
      return;
    }

    // Fallback for anything without IntersectionObserver.
    var frame = 0;
    function onScroll() {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(function () {
        if (anchor) pastAnchor = anchor.getBoundingClientRect().bottom < 0;
        if (tail) {
          var r = tail.getBoundingClientRect();
          atEnd = r.top < window.innerHeight && r.bottom > 0;
        }
        sync();
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ss-sticky]').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
